import React from "react";
import styles from "./module.style.scss";
import { getFormattedDate } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { capitalizeFirstLetter, formattedPrice, formatNumber } from "../../utils";
const headers = [
  "Seq No.",
  "Item Type",
  "Pay Mode",
  "Cheque No.",
  "Cheque Date",
  "Amount Paid",
  "Total AMT",
  "Deposit Date",
  "Payment Status",
  "Receipt No",
];

const formatePaymentMode = (paymentMode) => {
   const paymentModeMap = {CHKL:"Cheque"}
   return paymentModeMap[paymentMode] || paymentMode;
}

const PaymentHistoryTable = ({ rows, loading }) => {
  return (
    <div className="cancel-cheque-table-container">
      <div className=" cancel-cheque-table-header text-bold text-dark cancel-cheque-table">
        {headers.map((item ,index) => (
          <div key={item} className="">
            {item}
          </div>
        ))}
      </div>

      {rows.map((item, index) => (
        <div className="cancel-cheque-table">
          <div>{formatNumber(index+1)}</div>
          <div>{item?.itemType}</div>
          <div>{formatePaymentMode(item.paymentMode)}</div>
          <div>{item.chequeNo}</div>
          <div>{getFormattedDate(item.chequeDate)}</div>
          <div>{formattedPrice(item.amountPaid)}</div>
          <div>{formattedPrice(item.totalAmount)}</div>
          <div>{getFormattedDate(item.depositDate)}</div>
          <div>{capitalizeFirstLetter(item.paymentStatus)}</div>
          <div>{item.receiptNo}</div>
        </div>
      ))}
      {rows.length === 0 && !loading && <div className="text-center text-bold">No data available</div>}
    </div>
  );
};

export default PaymentHistoryTable;
